var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrash = function SvgIconTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 33"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D5E2F2",
    filter: "url(#icon_trash_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4 8.1v.6h5.1a.9.9 0 1 1 0 1.8h-15a.9.9 0 0 1 0-1.8h5.1v-.6a1.2 1.2 0 0 1 1.2-1.2h2.4a1.2 1.2 0 0 1 1.2 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.4 12.96a.66.66 0 0 1 .66-.66h11.88a.66.66 0 0 1 .66.66v11.82a1.32 1.32 0 0 1-1.32 1.32H9.72a1.32 1.32 0 0 1-1.32-1.32zM12 16.8a.9.9 0 1 1 1.8 0v4.8a.9.9 0 0 1-1.8 0zm5.1-.9a.9.9 0 0 0-.9.9v4.8a.9.9 0 0 0 1.8 0v-4.8a.9.9 0 0 0-.9-.9",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon_trash_svg__a",
    width: 36,
    height: 36,
    x: -3,
    y: -0.9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1079_18651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1079_18651",
    result: "shape"
  })))));
};
export default SvgIconTrash;